import type { SpiffReportMetadata } from "@/api/dto/process-instance";
import { CASE_STATUSES, type CaseStatus } from "@/domain/case/case";

import type { CaseListFilters } from "./build-case-report-metadata";

const EMPTY_FILTERS: CaseListFilters = {
  keyword: "",
  statuses: [],
  processModelId: null,
  submittedFrom: null,
  submittedTo: null,
};

/**
 * 保存ビュー（SpiffArena の report）から UI のフィルタ状態を復元する。
 *
 * `filter_by` の生ステータスからは draft / returned を一意に戻せないため、
 * 保存時に同梱した `ui_filters` を情報源にする。他ツールで作られた report には
 * それが無いので、その場合は既定値（絞り込みなし）にする。
 */
export function parseCaseReportMetadata(
  metadata: SpiffReportMetadata,
): CaseListFilters {
  const ui = metadata.ui_filters;
  if (ui === undefined || ui === null) return EMPTY_FILTERS;

  return {
    keyword: asString(ui.keyword) ?? "",
    statuses: asStatuses(ui.statuses),
    processModelId: asString(ui.processModelId),
    submittedFrom: asString(ui.submittedFrom),
    submittedTo: asString(ui.submittedTo),
  };
}

function asString(value: unknown): string | null {
  return typeof value === "string" && value !== "" ? value : null;
}

/** 保存内容は編集され得るので、既知のステータスだけを残す。 */
function asStatuses(value: unknown): readonly CaseStatus[] {
  if (!Array.isArray(value)) return [];

  return value.filter((item): item is CaseStatus =>
    (CASE_STATUSES as readonly unknown[]).includes(item),
  );
}
